import { render, staticRenderFns } from "./manage_pc.vue?vue&type=template&id=88f31ee2&scoped=true&"
import script from "./manage_pc.vue?vue&type=script&lang=js&"
export * from "./manage_pc.vue?vue&type=script&lang=js&"
import style0 from "./manage_pc.vue?vue&type=style&index=0&id=88f31ee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f31ee2",
  null
  
)

export default component.exports